import styled from '@emotion/styled';
import { withConfig } from 'src/withConfig';
import { StreamLoginIcon } from 'src/domains/layouts/shared/assets/icons/StreamLoginIcon';

interface MatchLeadStreamGateWrapperPropsType {
    bgImage?: string;
}

export const MatchLeadStreamGateWrapper = withConfig(theme => styled('div', { label: 'MatchLeadStreamGateWrapper' })<MatchLeadStreamGateWrapperPropsType>`
    align-items: center;
    background-color: ${theme.star.stream.bgColor};
    background-image: ${({ bgImage }): string => (bgImage === undefined ? 'none' : `url(${bgImage})`)};
    background-position: center;
    background-size: cover;
    display: flex;
    justify-content: center;
    min-height: 220px;
    padding: 24px 16px;
    position: relative;
    width: 100%;

    &::before {
        background-color: ${theme.star.overlay.bgColorSecondary};
        content: '';
        inset: 0;
        position: absolute;
    }

    > * {
        position: relative;
        z-index: 1;
    }
`);

export const MatchLeadStreamGateCard = withConfig(theme => styled('div', { label: 'MatchLeadStreamGateCard' })`
    align-items: center;
    background-color: ${theme.star.overlay.bgColorSecondary};
    border-radius: ${theme.star.radius.large};
    display: flex;
    flex-direction: column;
    gap: 12px;
    max-width: 480px;
    padding: 24px 20px;
    text-align: center;
    width: 100%;
`);

export const MatchLeadStreamGateIcon = withConfig(theme => styled(StreamLoginIcon, { label: 'MatchLeadStreamGateIcon' })`
    color: ${theme.star.stream.txtColor};
    flex-shrink: 0;
    height: 48px;
    margin-bottom: 4px;
    width: 48px;
`);

export const MatchLeadStreamGateTitle = withConfig(theme => styled('p', { label: 'MatchLeadStreamGateTitle' })`
    color: ${theme.star.stream.txtColor};
    font-size: ${theme.star.fontSize.regular};
    font-weight: ${theme.star.fontWeight.bold};
    line-height: 1.3;
    margin: 0;
`);

export const MatchLeadStreamGateButton = withConfig(theme => styled('button', { label: 'MatchLeadStreamGateButton' })`
    appearance: none;
    background-color: ${theme.star.watchLiveButton.bgColor};
    border: 0;
    border-radius: ${theme.star.radius.small};
    color: ${theme.star.watchLiveButton.txtColor};
    cursor: pointer;
    font-size: ${theme.star.fontSize.small};
    font-weight: ${theme.star.fontWeight.bold};
    line-height: 1.2;
    margin-top: 4px;
    max-width: 200px;
    min-height: 40px;
    padding: 10px 24px;
    width: 100%;

    &:focus {
        outline: none;
    }
`);
